// extracted by mini-css-extract-plugin
module.exports = {"grid":"seance-grid_grid__17WGk"};